import ServiceTypeEnum from '../Enums/ServiceTypeEnum';
import ServiceListItem from './ServiceListItem';
import InPersonServiceItem from './ServiceListItemTypes/InPersonServiceItem';
import PhoneServiceItem from './ServiceListItemTypes/PhoneServiceItem';
import OnlineWebServiceItem from './ServiceListItemTypes/OnlineWebServiceItem';
import InterceptsServiceItem from './ServiceListItemTypes/InterceptsServiceItem';
import AuditsServiceItem from './ServiceListItemTypes/AuditsServiceItem';
import CustomerSatisfactionServiceItem from './ServiceListItemTypes/CustomerSatisfactionServiceItem';
import EmployeeSurveyServiceItem from './ServiceListItemTypes/EmployeeSurveyServiceItem';
import OtherServiceItem from './ServiceListItemTypes/OtherServiceItem';
import OnlineReputationServiceItem from './ServiceListItemTypes/OnlineReputationServiceItem';
import BusinessIntelligenceServiceItem from './ServiceListItemTypes/BusinessIntelligenceServiceItem';
import BareIfyServiceItem from './ServiceListItemTypes/BareIfyServiceItem';
import InventoryAuditsServiceItem from './ServiceListItemTypes/InventoryAuditsServiceItem';

type ServiceTypeInput = {
  TypeCode: number;
};

// Class constructor type used by the factory. Each mapped value must be a
// ServiceListItem-derived class constructor.
type ServiceListItemClass = typeof ServiceListItem;

// Lookup table that maps a numeric service TypeCode to the corresponding
// ServiceListItem implementation.
//
// Notes:
// - Some type codes intentionally share the same class (e.g. Video -> Phone).
// - Missing/unknown type codes are handled by the default fallback in
//   getServiceListItemType.
const serviceItemByType: Record<number, ServiceListItemClass> = {
  [ServiceTypeEnum.InPerson]: InPersonServiceItem,
  [ServiceTypeEnum.Phone]: PhoneServiceItem,
  [ServiceTypeEnum.Video]: PhoneServiceItem,
  [ServiceTypeEnum.OnlineWeb]: OnlineWebServiceItem,
  [ServiceTypeEnum.FaceToFaceIntercepts]: InterceptsServiceItem,
  [ServiceTypeEnum.AuditsPricing]: AuditsServiceItem,
  // Pricing Audits (15) is a separate type that shares the Audits/Price-QA form.
  [ServiceTypeEnum.PricingAudits]: AuditsServiceItem,
  [ServiceTypeEnum.CustomerSatisfaction]: CustomerSatisfactionServiceItem,
  [ServiceTypeEnum.EmployeeSurvey]: EmployeeSurveyServiceItem,
  [ServiceTypeEnum.Other]: OtherServiceItem,
  [ServiceTypeEnum.OnlineReputation]: OnlineReputationServiceItem,
  [ServiceTypeEnum.BusinessIntelligence]: BusinessIntelligenceServiceItem,
  [ServiceTypeEnum.BareIfy]: BareIfyServiceItem,
  [ServiceTypeEnum.InventoryAudits]: InventoryAuditsServiceItem,
};

// Factory: returns the concrete ServiceListItem class based on TypeCode.
// Unknown type codes fall back to the base ServiceListItem.
const getServiceListItemType = (item: ServiceTypeInput): ServiceListItemClass => {
  return serviceItemByType[item.TypeCode] || ServiceListItem;
};

export default getServiceListItemType;
